import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/delete`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/delete`;

export const URL = (fieldReportId: number): RouteDefinition => `${baseRoute}/${fieldReportId}/delete`;
